// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const BoldOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 384 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M0 56c0-13.3 10.7-24 24-24h188c68.5 0 124 55.5 124 124 0 34.7-14.3 66.2-37.3 88.7 41 20.2 69.3 62.4 69.3 111.3 0 68.5-55.5 124-124 124H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V80H24C10.7 80 0 69.3 0 56zm212 176c42 0 76-34 76-76s-34-76-76-76H96v152h116zM96 280v152h148c42 0 76-34 76-76s-34-76-76-76H96z"}}]},"name":"bold","theme":"outlined"};

const BoldOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={BoldOutlinedSvg} />;
  BoldOutlined.displayName = 'BoldOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(BoldOutlined);
